import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { pickBy } from "lodash"

import { pagesLinks } from "../../pages-data/common/links"

import styles from "./styles.module.styl"

const pagesForBreadcrumbs = pickBy(pagesLinks, page => {
	const excludedPages = [
		"Поддержка",
		"Справочник ресторатора",
		"Блог",
		"Доставка и оплата",
		"Начать бесплатно",
		"Заказать приложение",
		"Войти",
		"API",
		"Личный кабинет",
		"Магазин",
		"",
		undefined,
	]

	if (!excludedPages.includes(page.text) || page.description) {
		return page
	}
})

function getBreadcrumbs(key) {
	const { pathname } = window.location

	function getTemplate(lastCrumb, amidLinks) {
		let breadcrumbsAmidLinks = ""

		if (amidLinks) {
			breadcrumbsAmidLinks = amidLinks.map(link => (
				<>
					<Link to={link.href}>{link.text || link.description}</Link>
					{" / "}
				</>
			))
		}

		return (
			<>
				<Link to="/">{"Главная"}</Link>
				{" / "}

				{breadcrumbsAmidLinks}

				<span>{lastCrumb.text || lastCrumb.description}</span>
			</>
		)
	}

	switch (true) {
		case pathname.includes(pagesForBreadcrumbs[key].compare?.href):
			return getTemplate(pagesForBreadcrumbs[key].compare, [
				pagesForBreadcrumbs[key],
			])

		case pathname.includes(pagesForBreadcrumbs[key].cafe?.href):
			return getTemplate(pagesForBreadcrumbs[key].cafe)

		case pathname.includes(pagesForBreadcrumbs[key].coffeehouse?.href):
			return getTemplate(pagesForBreadcrumbs[key].coffeehouse)

		case pathname.includes(pagesForBreadcrumbs[key].lite?.href):
			return getTemplate(pagesForBreadcrumbs[key].lite, [
				pagesForBreadcrumbs[key],
			])

		case pathname.includes(pagesForBreadcrumbs[key].pro?.href):
			return getTemplate(pagesForBreadcrumbs[key].pro, [
				pagesForBreadcrumbs[key],
			])

		case pathname.includes(pagesForBreadcrumbs[key].friend?.href):
			return getTemplate(pagesForBreadcrumbs[key].friend, [
				pagesForBreadcrumbs[key],
			])

		case pathname.includes(pagesForBreadcrumbs[key].annex?.href):
			return getTemplate(pagesForBreadcrumbs[key].annex, [
				pagesForBreadcrumbs[key],
			])

		case pathname.includes(pagesForBreadcrumbs[key]?.href):
			return getTemplate(pagesForBreadcrumbs[key])

		default:
			return undefined
	}
}

export default function Breadcrumbs(props) {
	const [breadcrumbs, setBreadcrumbs] = useState("")

	useEffect(() => {
		let breadcrumbs

		for (let key in pagesForBreadcrumbs) {
			breadcrumbs = getBreadcrumbs(key)

			if (breadcrumbs === undefined) {
				continue
			}

			setBreadcrumbs(breadcrumbs)

			return
		}
	}, [])

	return (
		<div className={`${styles.breadcrumbs} ${props.className || ""}`}>
			{breadcrumbs}
		</div>
	)
}

Breadcrumbs.propTypes = {
	className: PropTypes.string,
}
